export default {
  settings: {
    title: 'Configuracion',
    account: 'Cuenta',
    appSettings: 'Configuracion de la App',
    dataPrivacy: 'Datos y Privacidad',
    emptyProfile: 'No hay datos de perfil disponibles. Completa el onboarding para rellenar tu perfil.',
    emptyState: {
      title: 'No pudimos detectar datos de perfil guardados.',
      body: 'Ejecuta el onboarding para que la planificacion de quests tenga los datos que necesita.',
    },
    appLanguage: {
      title: 'Idioma de la App',
      description: 'Elige el idioma predeterminado de la app y de la IA.',
      save: 'Guardar Idioma',
      saving: 'Guardando...',
      updated: 'Preferencia de idioma actualizada.',
      error: 'No se pudo actualizar la preferencia de idioma.',
    },
    metricUnits: 'Metrico (kg, km)',
    managePlan: 'Gestionar plan',
    levelBadge: 'Nivel {level}',
    profileSection: 'Perfil',
    trainingSection: 'Entrenamiento',
    nutritionSection: 'Nutricion',
    equipmentSection: 'Equipo',
    bodyCompositionSection: 'Composicion corporal',
    healthNutritionSection: 'Salud y nutricion',
    profileSnapshot: 'Resumen del perfil',
    preferencesSection: 'Preferencias',
    fullExtractedProfile: 'Perfil extraido completo',
    completeOnboardingFirst: 'Completa primero el onboarding y luego vuelve aqui para editar tu perfil guardado.',
    profileUpdatedNoQuestChange: 'Perfil actualizado. Las quests permanecen sin cambios.',
    labels: {
      fullName: 'Nombre completo',
      age: 'Edad',
      gender: 'Genero',
      location: 'Ubicacion',
      height: 'Altura',
      weight: 'Peso',
      exerciseFamiliarity: 'Familiaridad con el ejercicio',
      weeklyActivity: 'Actividad semanal',
      sessionsPerWeek: 'Sesiones por semana',
      preferredWorkoutDays: 'Dias preferidos para entrenar',
      fitnessGoals: 'Objetivos fitness',
      workoutStyles: 'Estilos de entrenamiento',
      preferredUnits: 'Unidades preferidas',
      availableEquipment: 'Equipo disponible',
      notes: 'Notas',
      medicalConditions: 'Condiciones medicas, lesiones o dolor',
      dietaryPreferences: 'Preferencias alimentarias',
      allergies: 'Alergias',
    },
    measurements: {
      neck: 'Cuello',
      chest: 'Pecho',
      waist: 'Cintura',
      hips: 'Caderas',
      thigh: 'Muslo',
    },
    training: {
      sessionsPerWeekValue: '{count} sesiones / semana',
    },
    nutrition: {
      allergiesValue: 'Alergias: {value}',
    },
    actions: {
      rescheduleTitle: 'Reprogramar quests',
      rescheduleDescription: 'Ajusta los datos de tu perfil e inicia un plan de quests nuevo cuando quieras.',
      editProfile: 'Editar perfil',
      editingProfile: 'Editando perfil',
      editProfileDescription: 'Actualiza tus datos y preferencias sin regenerar automaticamente las quests.',
    },
    push: {
      title: 'Notificaciones push',
      needsSetup: 'Se solicitaron las notificaciones, pero este iPhone todavia necesita sincronizar un token push valido.',
      permissionDenied: 'Las notificaciones estan bloqueadas en Ajustes del iPhone.',
      enabledDescription: 'Las notificaciones de quests, streak, clasificacion y duel estan activadas en este iPhone.',
      disabledDescription: 'Las notificaciones de quests, streak, clasificacion y duel estan desactivadas en este iPhone.',
      iosOnly: 'Las notificaciones push solo estan disponibles en la app iOS.',
      enabledFeedback: 'Notificaciones push activadas.',
      disabledFeedback: 'Notificaciones push desactivadas.',
      disabledInSettings: 'Las notificaciones push se desactivaron en Ajustes del iPhone.',
      deniedHelp: 'Las notificaciones estan desactivadas en Ajustes del iPhone. Activalas alli y vuelve a intentarlo.',
      updateFailed: 'No se pudieron actualizar las notificaciones push.',
      sendTest: 'Enviar push de prueba',
      sendingTest: 'Enviando push de prueba...',
      testDescription: 'Envia una notificacion unica a este iPhone e informa el estado actual de entrega de Expo.',
      lastTest: 'Ultimo resultado de la prueba',
      ticketId: 'ID del ticket',
      providerError: 'Error del proveedor',
      testDelivered: 'Notificacion de prueba entregada correctamente.',
      testPending: 'Notificacion de prueba aceptada. La confirmacion del receipt sigue pendiente.',
      testFailed: 'No se pudo enviar la notificacion push de prueba.',
      testStatusDelivered: 'Entregada',
      testStatusPending: 'Pendiente',
      testStatusAccepted: 'Aceptada',
      testStatusNotReady: 'No lista',
      testStatusError: 'Error',
      openSettings: 'Abrir Ajustes del iPhone',
    },
    healthKit: {
      title: 'Verificacion de HealthKit',
      description: 'Gestiona el acceso de iOS a HealthKit para verificar pasos, sueno y calorias activas.',
    },
    guideRestore: {
      title: 'Restaurar guia de funciones',
      description: 'Vuelve a abrir la guia del dashboard y los consejos del producto.',
      successTitle: 'Exito',
      successBody: 'Guia de funciones restaurada. Revisa tu Dashboard.',
    },
    aboutForza: {
      title: 'About Forza',
      description: 'Abre la guia publica, la vision general del producto y la informacion de lanzamiento.',
    },
    healthSources: {
      title: 'Fuentes de salud',
      description: 'Mira de donde salen los consejos de salud y los valores por defecto de planificacion de Forza, con enlaces a las fuentes originales.',
    },
    support: {
      title: 'Soporte',
      description: 'Recibe ayuda y contactanos directamente.',
    },
    logout: {
      title: 'Cerrar sesion',
      description: 'Cierra sesion en tu cuenta en este dispositivo.',
    },
    download: {
      title: 'Descargar mis datos',
      description: 'Exporta tu perfil, configuracion e historial de quests.',
      started: 'Descarga de datos iniciada.',
      failed: 'No se pudieron descargar los datos.',
    },
    delete: {
      title: 'Eliminar cuenta',
      description: 'Elimina permanentemente tu cuenta y anonimiza todos los datos vinculados.',
      footnote: 'Eliminar tu cuenta anonimiza tu perfil y elimina los snapshots de HealthKit. Los registros de auditoria permanecen anonimizados hasta 12 meses.',
      modalTitle: 'Eliminar tu cuenta',
      modalBody: 'Esto eliminara permanentemente tu cuenta. Tu correo, nombre de usuario y datos del perfil se anonimizaran. Los snapshots de HealthKit se eliminan. Los registros anonimizados se conservan hasta 12 meses para auditoria y prevencion de fraude.',
      confirmLabel: 'Escribe DELETE para confirmar',
      confirmPlaceholder: 'DELETE',
      cancel: 'Cancelar',
      confirm: 'Eliminar cuenta',
      deleting: 'Eliminando...',
      typeDelete: 'Escribe DELETE para confirmar la eliminacion de la cuenta.',
      failed: 'No se pudo eliminar la cuenta. Vuelve a intentarlo.',
    },
    plan: {
      limitReached: 'Se alcanzo el limite de regeneracion de quests.',
      alreadyRunning: 'La regeneracion del plan de quests ya esta en curso.',
      failedDefault: 'La regeneracion de quests no se completo. Vuelve a intentarlo cuando quieras.',
      inProgressTitle: 'La regeneracion del plan de quests esta en curso.',
      triggeredBy: 'Activado por {source}',
      triggeredBySystem: 'Activado por el sistema',
      startedAt: 'Empezo a las {time}',
      autoUpdate: 'El dashboard se actualizara automaticamente.',
      failedTitle: 'La regeneracion del plan de quests fallo.',
      lastAttempt: 'El ultimo intento termino a las {time}. Vuelve a intentarlo cuando quieras.',
      rescheduling: 'Reprogramando...',
      rescheduleFailed: 'Reprogramacion fallida',
      rescheduleComplete: 'Reprogramacion completa',
    },
    assessment: {
      title: 'Fitness Assessment',
      completed: 'Completado',
      skipped: 'Omitido',
      available: 'Disponible',
      description: 'Completa esta baseline auto reportada una sola vez para recalibrar la dificultad de las quests futuras. Si tu nivel actual es mas alto, se conserva el nivel ganado.',
      close: 'Cerrar assessment',
      start: 'Iniciar assessment',
      assignedLevel: 'Nivel asignado',
      submitted: 'Enviado',
      qualityHeadline: 'Elige calidad de movimiento controlado por encima de numeros maximos.',
      qualityBody: 'Selecciona la variante mas dificil que puedas hacer con seguridad e introduce el resultado. El envio es una sola vez.',
      resultPlaceholder: 'Resultado',
      safetyNote: 'Este assessment es auto reportado y no sustituye una autorizacion medica. Detente si algo se siente mal.',
      submit: 'Enviar assessment unico',
      submitting: 'Enviando assessment...',
      submittedFeedback: 'Fitness assessment enviado.',
      submitFailed: 'No se pudo enviar el fitness assessment.',
      raiseLevelConfirm: 'Enviar este assessment unico subira tu baseline inicial y regenerara las quests futuras incompletas. Continuar?',
    },
    errors: {
      save: 'Se produjo un error al guardar.',
    },
  },
  appShell: {
    loading: 'Cargando...',
  },
  playerStats: {
    locked: 'Bloqueado',
    syncedAt: 'Sincronizado a las {time}',
    greeting: 'Hola {name}',
    timeLeft: 'Quedan {time}',
    nutritionToday: 'Nutricion de hoy',
    caloriesBurned: 'Calorias quemadas',
    notSynced: 'Sin sincronizar',
    workoutVerified: 'Workout verificado',
    workoutInProgress: 'Workout en curso',
    activeEnergyToday: 'Energia activa de hoy',
    healthKitStepsTitle: 'Objetivo de 10.000 pasos',
    healthKitSleepTitle: 'Objetivo de 7 horas de sueno',
    healthKitPrompt: 'Activa la verificacion de HealthKit en Ajustes de iOS para seguir los pasos, el sueno y las calorias activas de hoy.',
    healthKitSyncHint: 'La sincronizacion se realiza al abrir la app y al volver al primer plano, como maximo cada 15 minutos.',
    healthKitEnableStatus: 'Activa la verificacion de HealthKit en Ajustes del iPhone',
    healthKitCompleted: 'Completado',
    healthKitWaiting: 'Esperando la sincronizacion de HealthKit',
    healthKitInProgress: 'En curso',
  },
  coachLocked: {
    title: 'AI Coach',
    subtitle: 'Funcion solo disponible en Ultra',
    upgrade: 'Pasar a Ultra',
  },
  auth: {
    loginTitle: 'Bienvenido de nuevo',
    loginSubtitle: 'Retoma donde lo dejaste.',
    email: 'Correo electronico',
    password: 'Contrasena',
    signIn: 'Iniciar sesion',
    continueWith: 'O continua con',
    signInWithApple: 'Iniciar sesion con Apple',
    signInWithGoogle: 'Iniciar sesion con Google',
    createAccount: 'Nuevo aqui? Crea tu cuenta',
    registerTitle: 'Crea tu cuenta',
    registerSubtitle: 'Configura tu perfil y desbloquea tu primer plan.',
    username: 'Nombre de usuario',
    confirmPassword: 'Confirmar contrasena',
    register: 'Crear cuenta',
    signUpWithApple: 'Registrate con Apple',
    signUpWithGoogle: 'Registrate con Google',
    alreadyHaveAccount: 'Ya tienes una cuenta? Inicia sesion',
    inviteOnlyTitle: 'El acceso anticipado sigue siendo selectivo',
    inviteOnlySubtitle: 'Estamos incorporando nuevos miembros poco a poco para mantener una experiencia cuidada y un coaching de alta calidad.',
    needAccess: 'Necesitas acceso? Solicita early access',
    alreadyApproved: 'Ya aprobado?',
    approvedEmailPrompt: 'Usa el correo que recibio la aprobacion para desbloquear el registro.',
    approvedEmailPlaceholder: 'Correo aprobado',
    checking: 'Comprobando...',
    continue: 'Continuar',
    unlockReady: 'El registro esta listo para desbloquearse',
    unlockReadyDescription: 'Tu correo aprobado esta a punto de abrir el registro. Completa el alta enseguida para que el desbloqueo no expire.',
    registrationUnlocked: 'Registro desbloqueado',
    registrationUnlockedDescription: 'Esta aprobacion abre el registro por poco tiempo. Completar la cuenta la consumira de forma permanente.',
    approvedEmail: 'Correo aprobado: {email}',
    termsAgreement: 'He leido y acepto los Terminos del Servicio y la Politica de Privacidad.',
    ageConfirm: 'Confirmo que tengo al menos 16 anos.',
    aiConsent: 'Consiento el procesamiento de datos AI requerido.',
    viewDetails: 'Ver detalles',
    consentTag: 'Datos y Privacidad',
    consentTitle: 'Procesamiento de datos AI',
    consentProcessed: 'Datos que pueden procesarse',
    consentProviders: 'Proveedores de AI y voz',
    consentInfrastructure: 'Proveedores de infraestructura',
    consentWhenSent: 'Cuando se envian los datos',
    consentAgree: 'Aceptar y continuar',
    consentDecline: 'Rechazar',
    consentClose: 'Cerrar los detalles del procesamiento de datos AI',
    consentIntro:
      'Forza usa proveedores de AI y voz de confianza para generar quests personalizadas, acompañarte con coaching, verificar completados, revisar la tecnica y activar las funciones AI relacionadas.',
    consentProcessedItems: {
      profile: 'Objetivos fitness, preferencias, contexto del perfil y respuestas del onboarding.',
      quests: 'Planes de quests, actividad de quests, estado de completado y contexto de verificacion.',
      text: 'Textos que envias a las funciones con AI.',
      voice: 'Grabaciones de voz y transcripciones enviadas a Voice Coach o a la verificacion por voz.',
      photos: 'Fotos enviadas para verificar meals u otras quests.',
      exercise: 'Fotogramas de ejercicios enviados para revisar la tecnica.',
      diagnostics: 'Contexto de app, dispositivo y diagnostico necesario para operar, proteger y depurar estas funciones.',
    },
    consentProvidersBody:
      'Forza puede usar Google, Groq, OpenRouter, DeepSeek, OpenAI y proveedores locales o on-device cuando esten disponibles.',
    consentInfrastructureBody:
      'Los datos relacionados tambien pueden ser tratados por proveedores usados para hosting, almacenamiento, entrega de medios, monitorizacion, suscripciones, consentimiento publicitario, atribucion de recompensas y seguridad, incluidos Render, MongoDB Atlas, Cloudflare R2, ImageKit, Better Stack, Apple, RevenueCat y Google AdMob cuando corresponda.',
    consentWhenSentItems: {
      onboarding: 'Durante el onboarding y la generacion de quests.',
      coach: 'Cuando usas AI Coach o Voice Coach.',
      verification: 'Cuando envias notas de voz, fotos o fotogramas de ejercicios para verificacion o form check.',
      planning: 'Cuando las funciones con AI necesitan contexto de la app para responder, verificar progreso o planificar quests.',
    },
    consentFooter:
      'Forza no vende tus datos personales ni los comparte para publicidad o perfilado de terceros. Estos proveedores procesan los datos solo cuando es necesario para prestar los servicios de Forza y deben ofrecer la misma proteccion descrita en nuestra Politica de Privacidad.',
    unexpectedError: 'Algo salio mal. Intentalo de nuevo.',
    noAccountFound: 'No se encontro ninguna cuenta. Registrate primero para crear una.',
    authCreateFailed: 'La autenticacion fallo mientras se creaba la cuenta. Intentalo de nuevo.',
    accountDeleted: 'Esta cuenta ha sido eliminada.',
    appleMissingEmail: 'Apple Sign In no proporciono una direccion de correo para esta cuenta.',
    appleUnavailable: 'Apple Sign In no esta disponible en este entorno.',
    appleUnavailableDetailed:
      'Apple Sign In no esta disponible en este simulador o dispositivo. Pruebalo en un iPhone real si el simulador no completa la autenticacion de Apple.',
    appleInternalError:
      'Apple Sign In llego a Forza pero el servidor no pudo verificar el token de Apple. Revisa los logs del backend y la configuracion del bundle de Apple.',
    appleInvalidIdentity: 'Apple Sign In no proporciono un identificador de cuenta valido. Intentalo de nuevo.',
    authFailed: 'La autenticacion fallo. Intentalo de nuevo.',
    googleLoginFailed:
      'No se encontró ninguna cuenta. Crea una cuenta y después inicia sesión.',
    registerRequirements:
      'Para crear tu cuenta tienes que aceptar los Terminos y la Politica de Privacidad, confirmar que tienes al menos 16 anos y consentir el procesamiento de datos AI requerido.',
    registerSuccess:
      'Cuenta creada. Verifica tu correo antes de iniciar sesion.',
    verificationSentTitle: 'Correo de verificación enviado',
    verificationSentBody:
      'Hemos enviado un enlace de verificación a {email}. Abre el enlace para confirmar tu dirección de correo electrónico y activar tu cuenta. Revisa tu bandeja de entrada y también la carpeta de spam o correo no deseado.',
    verificationInitialFailure:
      'Tu cuenta se ha creado, pero no se pudo enviar el correo de verificación. Solicita otro correo a continuación.',
    verificationResend: 'Reenviar correo de verificación',
    verificationResending: 'Enviando...',
    verificationRetryCountdown: 'Podrás solicitar otro correo dentro de {seconds} segundos.',
    verificationResendError: 'No se puede enviar otro correo de verificación en este momento.',
    backToSignIn: 'Volver a iniciar sesión',
    unlockApprovalFound: 'Aprobacion encontrada. Confirma para desbloquear el registro.',
    unlockConsumed: 'Este correo aprobado ya se ha usado para crear una cuenta.',
    unlockMissing: 'Este correo no esta aprobado para early access en este momento.',
    unlockCheckFailed: 'No se puede comprobar el estado de aprobacion ahora mismo.',
    unlockIssueFailed: 'No se puede desbloquear el registro ahora mismo.',
    unlockCta: 'Desbloquear registro',
    approvedEmailWarningTitle: 'Usa el correo aprobado',
    approvedEmailWarningBody:
      'Este correo aprobado esta a punto de desbloquear el registro. Completa la creacion de la cuenta enseguida para que el desbloqueo no expire.',
    termsOfService: 'Terminos del Servicio',
    privacyPolicy: 'Politica de Privacidad',
    backToAboutForza: 'Volver a About Forza',
  },
  landingIntro: {
    startAria: 'Iniciar la intro de Forza',
    subprompt: 'Una app de longevidad',
    loading: 'Cargando intro...',
    enter: 'Toca para entrar en Forza',
    preparing: 'Preparando video...',
  },
  googleCallback: {
    processing: 'Procesando acceso...',
  },
  onboarding: {
    setupTag: 'Configuracion de Forza',
    modeChoiceTitle: 'Elige el ritmo de tu configuracion.',
    modeChoiceDescription:
      'La configuracion rapida te pone en marcha enseguida. La detallada da a Forza mas matices para que tu primer plan salga mejor afinado.',
    fastTitle: 'Configuracion rapida',
    fastDescription:
      'Un setup enfocado que captura lo esencial y deja listo tu primer plan rapidamente.',
    fastBestFor: 'Ideal si quieres arrancar ya.',
    detailedTitle: 'Configuracion detallada',
    detailedDescription:
      'Un setup mas profundo con medidas corporales, detalle de entrenamiento y preferencias de la app. Las unidades quedan metricas por defecto y puedes cambiarlas despues en Ajustes.',
    detailedBestFor: 'Ideal si quieres un arranque mas afinado.',
    loading: 'Cargando tu perfil de onboarding...',
    changePath: 'Cambiar ruta',
    progress: 'Progreso',
    step: 'Paso {current}',
    stepOf: 'Paso {current} de {total}',
    fullName: 'Nombre completo',
    age: 'Edad',
    height: 'Altura',
    weight: 'Peso',
    gender: 'Genero',
    location: 'Ubicacion',
    preferredUnits: 'Unidades preferidas',
    options: {
      gender: {
        Male: 'Hombre',
        Female: 'Mujer',
        Other: 'Otro',
      },
      activity: {
        '1-2 days per week': '1-2 dias por semana',
        '3-4 days per week': '3-4 dias por semana',
        '5-6 days per week': '5-6 dias por semana',
        '7 days per week': '7 dias por semana',
      },
      dietary: {
        Vegan: 'Vegana',
        Vegetarian: 'Vegetariana',
        'Gluten-Free': 'Sin gluten',
        'Low-Carb': 'Low-carb',
        Keto: 'Keto',
      },
      workout: {
        'Strength Training': 'Fuerza',
        Cardio: 'Cardio',
        Yoga: 'Yoga',
        Pilates: 'Pilates',
        HIIT: 'HIIT',
        Cycling: 'Ciclismo',
        Running: 'Correr',
        Meditation: 'Meditacion',
      },
      equipment: {
        None: 'Sin equipo',
        Dumbbells: 'Mancuernas',
        'Resistance bands': 'Bandas elasticas',
        Kettlebell: 'Kettlebell',
        'Pull-up bar': 'Barra de dominadas',
        'Gym access': 'Acceso al gimnasio',
      },
      familiarity: {
        Novice: 'Estoy empezando',
        Basic: 'Conozco lo basico',
        Comfortable: 'Entreno con soltura',
        Advanced: 'Entreno con confianza',
        'Expert/PT': 'Experto / entrenador',
      },
      familiarityDescriptions: {
        Novice: 'Mejor empezar con movimientos simples y pautas muy claras.',
        Basic: 'Conozco los movimientos principales y prefiero sesiones directas.',
        Comfortable: 'Puedo manejar bien una buena gama de ejercicios comunes.',
        Advanced: 'Me manejo bien con variaciones mas tecnicas y sesiones estructuradas.',
        'Expert/PT': 'Entiendo programacion, tecnica y progresiones avanzadas.',
      },
      units: {
        'Metric (kg, km)': 'Metrico (kg, km)',
        'Imperial (lbs, miles)': 'Imperial (lbs, miles)',
      },
      weekdays: {
        Mon: 'Lun',
        Tue: 'Mar',
        Wed: 'Mie',
        Thu: 'Jue',
        Fri: 'Vie',
        Sat: 'Sab',
        Sun: 'Dom',
      },
    },
    enterFullName: 'Introduce tu nombre completo',
    enterAge: 'Introduce tu edad',
    enterHeight: 'Introduce tu altura',
    enterWeight: 'Introduce tu peso',
    cityCountry: 'Ciudad, Pais',
    sessionsPerWeek: 'Sesiones por semana',
    preferredWorkoutDays: 'Dias preferidos de entrenamiento',
    preferredWorkoutDaysCount: '{selected}/{total} seleccionados',
    workoutDayHint:
      'El planner generara workouts solo en estos dias. Meals y mindfulness seguiran apareciendo cada dia.',
    trainingContextTitle: 'Contexto de entrenamiento',
    trainingContextDescription:
      'Esto ayuda a Forza a ajustar tu primera semana a tu experiencia, tu confianza y tu ritmo real.',
    weeklyActivity: 'Actividad semanal',
    fitnessGoals: 'Cuales son tus objetivos fitness?',
    fitnessGoalsPlaceholder: 'p. ej., ganar fuerza, perder grasa, volver a sentirme atletico...',
    tellUsAboutYourself: 'Cuéntanos sobre ti',
    basicsDescription: 'Estos datos dan forma al plan, al ritmo y a la manera en que Forza te acompana.',
    bodyTitle: 'Mide tu estructura',
    bodyDescription: 'Todos los campos de circunferencia son opcionales. Puedes dejarlos todos vacios y seguir igualmente al siguiente paso del onboarding.',
    optionalNotes: 'Notas opcionales',
    optionalNotesPlaceholder: 'Cualquier asimetria, enfoque actual o contexto de medicion.',
    dietaryPreferences: 'Preferencias alimentarias',
    allergiesToggle: 'Tengo alergias',
    allergiesPlaceholder: 'Enumera alergias o reacciones.',
    safetyNote: 'Nota de seguridad',
    safetyDescription: 'Usaremos esto para mantener el plan sensato. No sustituye una autorizacion medica.',
    medicalConditions: 'Condiciones medicas, lesiones o dolor',
    medicalConditionsPlaceholder: 'p. ej., asma, dolor de rodilla, lesion previa de hombro, o Ninguna.',
    preferencesTitle: 'Personaliza la experiencia',
    preferencesDescription: 'Ajusta la experiencia para que recordatorios, estilo de entrenamiento y equipo encajen con tu vida real.',
    pushNotifications: 'Notificaciones push',
    pushNotificationsDescription: 'Recibe recordatorios y actualizaciones de quests.',
    openIphoneSettings: 'Abrir Ajustes de iPhone',
    favouriteWorkoutStyles: 'Estilos de workout favoritos',
    equipmentYouOwn: 'Equipo que tienes',
    addCustomEquipment: 'Agregar equipo personalizado',
    add: 'Agregar',
    reviewTitle: 'Revisa tu configuracion',
    reviewDescription: 'Dale un ultimo repaso y luego decide si quieres calibrar tu nivel inicial antes de generar el primer plan.',
    reviewProfile: 'Perfil',
    reviewTraining: 'Entrenamiento',
    reviewEquipment: 'Equipo',
    reviewHealth: 'Salud y nutricion',
    notProvided: 'No proporcionado',
    none: 'Ninguno',
    name: 'Nombre',
    goal: 'Objetivo',
    familiarity: 'Familiaridad',
    workoutDays: 'Dias de workout',
    workoutStyles: 'Estilos de workout',
    units: 'Unidades',
    availableEquipment: 'Equipo disponible',
    healthNotes: 'Notas de salud',
    assessmentTitle: 'Fitness assessment opcional',
    assessmentDescription:
      'Usa esta autoevaluacion rapida para afinar tu nivel inicial. Si la saltas, Forza empezara de forma mas conservadora.',
    startAssessment: 'Iniciar assessment',
    startAssessmentDescription: 'Elige variaciones de ejercicios e introduce tu resultado en seis dominios aptos para casa.',
    skipForNow: 'Saltar por ahora',
    skipForNowDescription: 'Genera ahora quests iniciales conservadoras y deja la assessment disponible en Ajustes.',
    selfReportTitle: 'Prueba fitness autoinformada',
    selfReportDescription:
      'Elige la variacion mas dificil que puedas controlar bien y anota el resultado cuando haga falta. Forza la usa para fijar una base mas inteligente.',
    resultPlaceholder: 'Resultado',
    assessmentSafety:
      'Esto es autoinformado y solo debe hacerse si te sientes seguro. Detente si algo no se siente bien.',
    back: 'Atras',
    next: 'Siguiente',
    saving: 'Guardando...',
    continueToAssessment: 'Continuar a assessment',
    generatingQuests: 'Generando quests...',
    submitAssessment: 'Enviar assessment y generar quests',
    fastCoachIntro: 'Vamos a hacerlo rapido. Primero necesito lo esencial para que tu primer plan caiga en la zona correcta.',
    fastGoalPrompt: 'Que te gustaria que tu primer plan te ayudara a conseguir por encima de todo?',
    fastGoalPlaceholder:
      'p. ej., quiero perder grasa sin perder fuerza, entrenar 4 dias por semana y mejorar la constancia.',
    fastFamiliarityPrompt: 'Que tan seguro te sientes con la tecnica de ejercicio y la variedad de movimientos?',
    fastAvailabilityPrompt: 'En una semana real, cuantas veces puedes aparecer para entrenar o hacer recovery?',
    fastEquipmentPrompt: 'Con que equipo puede contar de verdad Forza?',
    fastHealthPrompt: 'Hay lesiones, molestias o limites que tu plan deba respetar?',
    fastHealthPlaceholder: 'Escribe Ninguna si no hay nada que señalar.',
    fastHealthHint: 'Si reportas una limitacion, Forza seguira adelante pero el plan deberia mantenerse conservador.',
    fastNutritionPrompt: 'Ultima cosa: hay preferencias alimentarias o alergias que las meal quests deban respetar?',
    errors: {
      loadProfile: 'No se pudo cargar tu perfil. Actualiza la pagina y vuelve a intentarlo.',
      saveProgress: 'No se pudo guardar el progreso del onboarding.',
      finalize: 'No se pudo completar el onboarding. Vuelve a intentarlo.',
      workoutDaysExact: 'Elige exactamente {count} dia{suffix} de workout antes de continuar.',
      pushDisabledExternal:
        'Las notificaciones push fueron desactivadas en Ajustes de iPhone. Activalas alli si quieres recordatorios de Forza.',
      pushDenied: 'Las notificaciones estan desactivadas en Ajustes de iPhone. Activalas alli y vuelve a intentarlo.',
      pushConfig: 'No se pudieron configurar las notificaciones push.',
    },
    steps: {
      chooseSetup: 'Elegir configuracion',
      personalInfo: 'Crear tu perfil',
      fitnessProfile: 'Contexto de entrenamiento',
      bodyComposition: 'Medidas corporales',
      healthDetails: 'Aspectos de salud',
      preferences: 'Preferencias de la app',
      review: 'Revisar y confirmar',
      assessment: 'Fitness assessment',
      fastBasics: 'Basicos',
      fastGoal: 'Objetivo',
      fastFamiliarity: 'Familiaridad con ejercicio',
      fastAvailability: 'Disponibilidad semanal',
      fastEquipment: 'Equipo',
      fastHealth: 'Notas de salud',
      fastNutrition: 'Notas de nutricion',
      fastReview: 'Revision',
    },
    bodyLabels: {
      neck: 'Cuello',
      chest: 'Pecho',
      waist: 'Cintura',
      hips: 'Caderas',
      thigh: 'Muslo',
      circumference: 'Circunferencia de {label}',
    },
    assessmentDomains: {
      push: {
        label: 'Empuje',
        prompt: 'Cuantas repeticiones controladas puedes completar?',
        variations: {
          easier: 'Flexion inclinada',
          standard: 'Flexion',
          harder: 'Flexion declinada',
        },
        variationDescriptions: {
          easier: 'Manos sobre una pared, banco o superficie elevada firme. Baja con control y vuelve a empujar.',
          standard: 'Manos en el suelo y cuerpo en linea recta. Baja con control y sube sin hundir la cadera.',
          harder: 'Pies elevados y manos en el suelo. Manten el cuerpo rigido mientras bajas y subes.',
        },
      },
      squat: {
        label: 'Sentadilla / zancada',
        prompt: 'Cuantas repeticiones controladas puedes completar?',
        variations: {
          easier: 'Sentadilla al cajon',
          standard: 'Sentadilla al aire',
          harder: 'Zancada inversa',
        },
        variationDescriptions: {
          easier: 'Lleva la cadera hacia una silla o cajon, tocalo suavemente y vuelve a subir con control.',
          standard: 'Pies al ancho de hombros. Baja en una sentadilla con el peso corporal y sube sin rebote.',
          harder: 'Lleva una pierna atras en zancada, baja con control y vuelve a ponerte de pie antes de cambiar de lado.',
        },
      },
      hinge: {
        label: 'Bisagra de cadera',
        prompt: 'Cuantas repeticiones controladas puedes completar?',
        variations: {
          easier: 'Puente de gluteos',
          standard: 'Good morning sin carga',
          harder: 'Peso muerto rumano a una pierna',
        },
        variationDescriptions: {
          easier: 'Tumbado boca arriba con los pies apoyados, eleva la cadera apretando los gluteos.',
          standard: 'De pie, lleva la cadera hacia atras con la espalda larga y vuelve arriba sin redondearte.',
          harder: 'En equilibrio sobre una pierna, inclinate desde la cadera con control y vuelve arriba sin girarte.',
        },
      },
      core: {
        label: 'Core',
        prompt: 'Cuanto tiempo puedes mantener una tecnica estable?',
        variations: {
          easier: 'Plancha de rodillas',
          standard: 'Plancha de antebrazos',
          harder: 'Plancha long lever',
        },
        variationDescriptions: {
          easier: 'Manten una linea estable desde hombros hasta rodillas con el abdomen activo.',
          standard: 'Manten una plancha de antebrazos con caderas niveladas y cuerpo en linea recta.',
          harder: 'Haz la plancha con los codos mas adelantados para aumentar la palanca sin perder tension.',
        },
      },
      cardio: {
        label: 'Cardio',
        prompt: 'Cuantos minutos puedes sostener un esfuerzo exigente pero controlado?',
        variations: {
          easier: 'Caminata rapida',
          standard: 'Trote o step-ups',
          harder: 'Carrera rapida o burpees',
        },
        variationDescriptions: {
          easier: 'Camina a un ritmo que eleve claramente la respiracion pero siga siendo controlable.',
          standard: 'Elige un trote suave o step-ups repetidos que se sientan exigentes pero sostenibles.',
          harder: 'Elige carrera rapida o burpees solo si puedes mantener el esfuerzo con control y seguridad.',
        },
      },
      mobility: {
        label: 'Movilidad',
        prompt: 'Elige el rango de movimiento sin dolor que puedas controlar mejor hoy.',
        variations: {
          very_limited: 'Muy limitado o doloroso',
          limited: 'Rango limitado y prudente',
          standard: 'Movimiento diario normal',
          deep_controlled: 'Rango amplio con control',
          deep_unrestricted: 'Rango amplio sin molestias',
        },
        variationDescriptions: {
          very_limited: 'El movimiento se corta pronto o duele, asi que debes parar mucho antes de un rango normal.',
          limited: 'Puedes moverte algo, pero el rango esta claramente reducido y requiere cautela.',
          standard: 'Puedes manejar movimientos cotidianos normales sin grandes limitaciones.',
          deep_controlled: 'Accedes a un rango amplio manteniendote estable y con control.',
          deep_unrestricted: 'Te mueves en un rango amplio con comodidad, sin dolor ni compensaciones claras.',
        },
      },
    },
    assessmentDifficulty: {
      easier: 'Mas facil',
      standard: 'Estandar',
      harder: 'Mas dificil',
      very_limited: 'Muy limitado',
      limited: 'Limitado',
      deep_controlled: 'Amplio',
      deep_unrestricted: 'Completo',
    },
    assessmentUnits: {
      reps: 'repeticiones',
      seconds: 'segundos',
      minutes: 'minutos',
      choice: 'seleccion',
    },
  },
  dashboard: {
    dailyQuests: 'Quests diarias',
    recoveryModeActive: 'Recovery Mode activa',
    recoveryModeDescription: 'Completa 3 workouts de recovery para restaurar el nivel completo.',
    viewWeeklyShoppingList: 'Ver lista de compra semanal',
    generationFailed: 'Fallo la generacion de quests.',
    unknownError: 'Error desconocido',
  },
  calendar: {
    title: 'Calendario',
    toggleSearch: 'Alternar busqueda',
    toggleFilter: 'Alternar filtro',
    toggleView: 'Alternar vista del calendario',
    searchPlaceholder: 'Buscar quests...',
    questsForDay: 'Quests del {date}',
    allScheduledQuests: 'Todas las quests programadas',
    noQuestsForDay: 'No hay quests programadas para este dia.',
    noQuestsFound: 'No se encontraron quests.',
    generatingAfterLevelUp: 'Generando nuevas quests despues del level-up...',
    filters: {
      all: 'Todas',
      workout: 'Entrenamiento',
      mind: 'Mind',
      mindfulness: 'Mindfulness',
      meal: 'Comida',
    },
    errors: {
      load: 'No se pudo cargar el calendario.',
      updateQuest: 'No se pudo actualizar esta quest ahora mismo.',
      updated: 'Quest actualizada.',
      movedTo: '{quest} movida a {target}.',
      swappedWith: '{quest} intercambiada con {target}.',
    },
  },
  header: {
    forza: 'Forza',
    leaderboard: 'Clasificacion',
    calendar: 'Calendario',
    settings: 'Configuracion',
    login: 'Iniciar sesion',
    register: 'Registrarse',
    navigation: 'Navegacion principal',
  },
  questCard: {
    healthKitOnly: 'Solo HealthKit',
    moveSwap: 'Mover o intercambiar quest',
    completed: 'Completada',
    locked: 'Bloqueada',
    viewHealthStatus: 'Ver estado de salud',
    liveCoach: 'Coach en vivo',
    live: 'En vivo',
    start: 'Iniciar',
    startMindSession: 'Iniciar la sesión Mind',
    verify: 'Verificar',
    verifyQuest: 'Verificar quest',
  },
  featureBanner: {
    dismiss: 'Cerrar guia',
    previous: 'Antes',
    next: 'Siguiente',
    jumpTo: 'Ir a la funcion {index}',
    items: {
      adaptiveTitle: 'Forza se adapta contigo',
      adaptiveDesc: 'Tus quests evolucionan segun tu nivel, constancia y objetivos.',
      missTitle: 'No dejes caer tus quests',
      missDesc: 'Las quests perdidas reducen XP, asi que la constancia protege tu impulso.',
      coachTitle: 'AI Coach',
      coachDesc: 'Toca el microfono de AI Coach cuando quieras consejo o un ajuste mejor del plan.',
      proofTitle: 'Proof of work',
      proofDesc: 'Haz 3 fotos de meals para verificar la quest y asegurar tu XP.',
      timedTitle: 'Sesiones de workout con temporizador',
      timedDesc: 'Toca Verificar y luego Iniciar temporizador para arrancar un workout guiado.',
      voiceTitle: 'Notas de voz',
      voiceDesc: 'Envia una nota de voz para verificar la quest y ganar el XP.',
      levelTitle: 'Sube de nivel',
      levelPrefix: 'Construye streaks',
      levelSuffix: 'para desbloquear recompensas.',
      aurasTitle: 'Gana auras',
      aurasDesc: 'Cada quest completada da 100 Auras. Una streak de 7 dias da 1000.',
      shopTitle: 'Usa las auras con estrategia',
      shopPrefix: 'Toca',
      shopSuffix: 'para abrir la tienda y activar mejoras de Forza.',
    },
  },
  consentGate: {
    summary:
      'Tus datos pueden enviarse a proveedores externos. El consentimiento es necesario para seguir usando Forza.',
    hideDetails: 'Ocultar detalles',
    declineConfirmation: 'Confirmacion de rechazo',
    declineBody:
      'Si rechazas el consentimiento para el procesamiento de datos AI, los datos de tu cuenta se eliminaran o anonimizaran y se cerrara tu sesion.',
    goBack: 'Volver',
    deleting: 'Eliminando cuenta...',
    declineDelete: 'Rechazar y eliminar cuenta',
    saving: 'Guardando consentimiento...',
  },
  emailVerification: {
    title: 'Verificacion de correo',
    missingToken: 'No se encontro ningun token de verificacion. Revisa el enlace.',
    verifying: 'Verificando tu correo...',
    success: 'Verificacion completada. Ya has iniciado sesion. Redirigiendo...',
    unknownError: 'Se produjo un error desconocido.',
    goToLogin: 'Ir al login',
  },
  moveSwap: {
    title: 'Mover / Intercambiar',
    description: 'Cambia cuando ocurre esta quest esta semana.',
    unavailable: 'No disponible',
    cancel: 'Cancelar',
    continue: 'Continuar',
    confirm: 'Confirmar',
    back: 'Atras',
    saving: 'Guardando...',
    optionMoveHere: 'Mover aqui',
    optionSwapWith: 'Intercambiar con {target}',
    moveTo: 'Mover a {target}?',
    swapWith: 'Intercambiar con {target}?',
    actions: {
      swap: 'Intercambiar',
      move: 'Mover',
    },
    reasons: {
      currentDay: 'Dia actual',
      completedQuest: 'Quest completada',
      completedWorkout: 'Entrenamiento completado',
      earlierEmptyDay: 'Dia anterior vacio',
      unavailable: 'No disponible',
      noMatchingQuest: 'No hay quest coincidente',
      noMindfulnessQuest: 'No hay quest de mindfulness',
    },
  },
  modal: {
    close: 'Cerrar',
  },
  recoveryModal: {
    title: 'Recovery Mode activa',
    subtitle: 'Bienvenido de nuevo',
    body1:
      'Notamos que llevabas un tiempo fuera. En lugar de bajar tu nivel, activamos Recovery Mode.',
    body2:
      'Tu nivel se ha conservado. Antes de volver al entrenamiento completo, Forza sugiere unos dias de actividad mas ligera como yoga, caminar o estiramientos.',
    quote: 'Descansar no es inactividad, es la clave para rendir mejor.',
    dontShowAgain: 'No mostrar de nuevo',
    cta: 'Iniciar recovery',
  },
  questDetails: {
    mediaReported: 'Media reportado',
    reportingMedia: 'Reportando media...',
    reportInaccurateMedia: 'Reportar media inexacto',
    mediaUnavailable: 'La imagen estara disponible pronto',
    aiGeneratedNotice: 'Media generado por IA. Lee la descripcion para una forma correcta.',
    expandMedia: 'Ampliar {label}',
    exerciseVideoAlt: 'Video del ejercicio',
    exerciseImageAlt: 'Imagen del ejercicio',
    mealImageAlt: 'Imagen del meal',
    closeExpandedImage: 'Cerrar imagen ampliada',
    time: 'Tiempo',
    calories: 'Calorias',
    sets: 'Series',
    reps: 'Repeticiones',
    rest: 'Descanso',
    seconds: '{count} segundos',
    suggestedWeight: 'Peso sugerido',
    estimatedCalories: 'Calorias estimadas',
    protein: 'Proteina',
    carbs: 'Carbohidratos',
    fat: 'Grasa',
    ingredients: 'Ingredientes',
    instructions: 'Instrucciones',
    current: 'Actual',
    verification: 'Verificacion',
    locked: 'Bloqueado',
    automatic: 'Automatica',
    healthKitLockedBody: 'Activa HealthKit en el iPhone dentro de la app Forza para desbloquear esta quest. Forza podra usar tus datos de Apple Health para seguir el progreso y marcar la quest como completada cuando se registre el objetivo.',
    healthKitActiveBody: 'Esta quest usa datos de Apple Health para la verificacion. La sincronizacion se ejecuta en la app del iPhone al abrirla y al volver al primer plano.',
    imageReportedForReview: 'Imagen reportada para revision.',
    reportImageFailed: 'No se pudo reportar la imagen.',
    detailsTitle: 'Detalles de {type}',
    viewSession: 'Abrir la sesión Mind',
    viewRecipe: 'Ver receta y nutricion',
    viewHealth: 'Ver verificacion de salud',
    viewRoutine: 'Ver rutina completa',
    expandedMedia: 'Media expandido de la quest',
    roundsLabel: 'Rondas',
    roundLabel: 'Ronda {number}',
    mindArchetype: 'Razonamiento lógico',
    mindSummary: 'Completa cuatro rondas breves para terminar la misión Mind de hoy.',
    mindRepeatDistance: 'La misma prueba no volverá a aparecer durante al menos {days} días.',
    na: 'N/D',
  },
  verificationModal: {
    checkingVoiceAvailability: 'Comprobando disponibilidad de nota de voz...',
    microphoneDenied: 'Acceso al microfono denegado. Habilitalo en la configuracion del navegador.',
    recordVoicePrompt: 'Graba tu voz para la verificacion.',
    verifying: 'Verificando con IA...',
    levelUp: 'Level Up! Has alcanzado el Nivel {level}.',
    failed: 'La verificacion no se completo. Intentalo de nuevo.',
    mealSubmitted: 'Verificacion de meal enviada.',
    dailySubmitted: 'Registro diario de comidas guardado.',
    verifyingQuestTitle: 'Verificando quest...',
    didYouKnow: 'Sabias que?',
    seeSources: 'Ver fuentes',
    title: 'Verificar Quest',
    mealDescription: 'Elige el metodo de verificacion. Captura tu meal o envia una nota de voz.',
    standardDescription: 'Elige el metodo de verificacion. Puedes grabar una nota de voz o iniciar un temporizador guiado.',
    startMealCapture: 'Iniciar captura de meal',
    checkingShort: 'Comprobando...',
    ultraMembers: 'Solo Ultra',
    unavailable: 'No disponible',
    completeAllMeals: 'Completa todas las comidas de hoy',
    alreadySentToday: 'Ya enviado hoy',
    recording: 'Grabando...',
    voiceNote: 'Nota de voz',
    startTimer: 'Iniciar temporizador',
    checkingFeatureAvailability: 'Comprobando disponibilidad de la funcion...',
    voiceRecorded: 'Nota de voz grabada ({size} KB)',
    cancel: 'Cancelar',
    submitVoiceNote: 'Enviar nota de voz',
  },
  mindSession: {
    category: 'Activación mental',
    close: 'Cerrar',
    unavailable: 'Esta sesión Mind no está disponible ahora mismo.',
    roundProgress: 'Ronda {current} de {total}',
    yourOrder: 'Tu orden',
    undo: 'Deshacer',
    clear: 'Limpiar',
    tapToBuild: 'Toca una ficha',
    availableTiles: 'Fichas disponibles',
    failedChecks: 'Intentos fallidos',
    roundValue: 'Máximo: {value} puntos',
    checkRound: 'Comprobar la ronda',
    completeQuest: 'Completar la misión Mind',
    saving: 'Guardando...',
    finishSequence: 'Termina la secuencia antes de comprobar la ronda.',
    tryAgain: 'Respuesta incorrecta. Revísala e inténtalo de nuevo.',
    roundCleared: 'Ronda completada. Pasa a la siguiente prueba.',
    lockingQuest: 'Guardando la sesión Mind...',
    submitFailed: 'No se ha podido guardar la sesión. Inténtalo de nuevo.',
    completedToday: 'Sesión Mind completada.',
    completeLabel: 'Sesión completada',
    completedBody: 'La sesión Mind de hoy ha terminado. Vuelve mañana para un nuevo desafío.',
    score: 'Puntuación',
    rounds: 'Rondas',
    perfect: 'Perfectas',
    badge: 'Insignia',
    zeroDrift: 'Recorrido perfecto',
    cleanControl: 'Control preciso',
    sharpFinish: 'Final brillante',
    previewing: 'Memoriza lo que ves. Podrás responder cuando termine la vista previa.',
    previewSequence: 'Secuencia que debes memorizar',
    replayPreview: 'Volver a ver la vista previa',
    replayPreviewCount: 'Volver a ver la vista previa ({used}/{total})',
    startPreview: 'Mostrar la vista previa',
    step: 'Elemento {number}',
    finishPattern: 'Selecciona todas las casillas necesarias antes de comprobar la ronda.',
    tryAgainPattern: 'La disposición no es correcta. Modifícala e inténtalo de nuevo.',
    selectAllTargets: 'Selecciona todos los elementos correctos antes de comprobar la ronda.',
    finishRule: 'Completa la regla activa antes de continuar.',
    nextRuleReady: 'Primera regla completada. Ahora aplica la siguiente.',
    nextRule: 'Siguiente regla',
    targetMiss: 'Elemento incorrecto. Continúa.',
    targetExactMatch: 'La selección contiene elementos incorrectos. Elimínalos e inténtalo de nuevo.',
    ruleMiss: 'Ese elemento no encaja con la regla activa.',
    ruleExactMatch: 'Algunos elementos no cumplen la regla activa. Corrige la selección e inténtalo de nuevo.',
    gridPrompt: 'Reconstruye la disposición mostrada',
    ruleStage: 'Regla activa',
    targetSet: 'Elementos disponibles',
    backToDashboard: 'Volver al panel principal',
    rotationStart: 'Orientación inicial',
    clockwise: 'Sentido horario',
    counterClockwise: 'Sentido antihorario',
    completeBadge: 'Mind completada',
    signalLadder: 'Progresión',
    missingStepProgress: 'Paso pendiente {current} de {total}',
    chooseMissingStep: 'Elige el paso que falta antes de comprobar la ronda.',
    progressionMismatch: 'Ese paso no completa la progresión. Inténtalo de nuevo.',
    mirrorAxis: 'Refleja de izquierda a derecha',
    classifyCards: 'Clasifica cada carta',
    classifyEveryCard: 'Asigna cada carta antes de comprobar la ronda.',
    classificationMismatch: 'Algunas cartas están en la categoría equivocada. Revisa ambas categorías e inténtalo de nuevo.',
    discardTitle: '¿Descartar esta sesión Mind?',
    discardBody: 'Perderás el progreso actual.',
    keepPlaying: 'Seguir jugando',
    discard: 'Descartar',
    reverseOrderHint: 'Empieza por el último elemento y continúa hacia atrás.',
    forwardOrderHint: 'Reconstruye la secuencia en el mismo orden.',
    optionsCanRepeat: 'Las opciones pueden repetirse',
    modeProgress: 'Regla',
    rememberedSequence: 'Secuencia que debes recordar',
    studyTraits: 'Fíjate en el orden y en las características de cada carta.',
    memorizeOrder: 'Memoriza cada elemento en el orden en que aparece.',
    yourFilteredSequence: 'Tu secuencia filtrada',
    yourReverseSequence: 'Tu secuencia al revés',
    placeMatchingCards: 'Coloca aquí las cartas correctas sin alterar el orden original.',
    fillSlotsInOrder: 'Completa todos los espacios numerados respetando el orden.',
    tapCardBelow: 'Toca una carta de abajo',
    candidateCards: 'Cartas disponibles',
    selectFilteredCards: 'Elige las cartas que cumplen la regla sin cambiar su orden.',
    mirrorPattern: 'Refleja la disposición',
    copyOppositeSide: 'Usa el modelo como referencia y reprodúcelo en el lado opuesto.',
    repeatFlashOrder: 'Toca las casillas en el mismo orden en que se iluminaron.',
    sourcePattern: 'Modelo original',
    yourMirror: 'Tu disposición reflejada',
    followVisualTrait: 'Sigue la característica visual de la carta: la palabra escrita puede contradecirla.',
    chooseCategoryEveryCard: 'Asigna cada elemento a una de las dos categorías.',
    gridCellLabel: 'Casilla {number}{selected}',
    gridCellSelected: ', seleccionada',
    filterRule: 'Elige solo {rule} y mantén el orden original.',
    warmTrait: 'Cálido',
    coolTrait: 'Frío',
    roundedTrait: 'Redondeada',
    angularTrait: 'Angular',
  },
  mealCapture: {
    allAnglesCaptured: 'Se capturaron todos los angulos requeridos.',
    cameraPreviewNotReady: 'La vista previa de la camara no esta lista.',
    angleCaptured: 'Angulo {angle} capturado.',
    discardConfirm: 'Quieres descartar las fotos capturadas y salir?',
    captureAllAngles: 'Captura los tres angulos antes de enviar.',
    submitting: 'Enviando fotos para la verificacion...',
    failed: 'La verificacion de meal no se completo. Intentalo otra vez.',
    rearCamera: 'Trasera',
    frontCamera: 'Frontal',
    back: 'Atras',
    title: 'Verificacion de Meal',
    deviceCamera: 'Dispositivo: camara {camera}',
    initializingCamera: 'Inicializando camara...',
    cameraRequired: 'Se requiere acceso a la camara para la verificacion de meal. Cambia a un dispositivo con camara.',
    captureInstruction: 'Instruccion de captura',
    captureButton: 'Capturar {angle}',
    switch: 'Cambiar',
    captureProgress: 'Progreso de captura',
    angleLabel: 'Angulo {angle}',
    captured: 'Capturado',
    pending: 'Pendiente',
    awaitingTurn: 'Esperando turno',
    retake: 'Repetir',
    anglePreview: 'Vista previa {angle}',
    descriptionOptional: 'Descripcion (opcional)',
    descriptionPlaceholder: 'Agrega cualquier detalle que quieras compartir...',
    cancel: 'Cancelar',
    submittingShort: 'Enviando...',
    submitPhotos: 'Enviar fotos',
    anglePrompts: {
      top: 'Captura primero el angulo superior.',
      front: 'Captura despues el angulo frontal.',
      side: 'Captura por ultimo el angulo lateral.',
    },
  },
  formCheck: {
    rearCameraTip: 'Si es posible, cambia a la camara trasera para tener un campo de vision mas amplio.',
    accessingCamera: 'Accediendo a la camara... acepta el permiso si aparece.',
    close: 'Cerrar',
    switchCameraLens: 'Cambiar lente de la camara',
    switching: 'Cambiando...',
    switchLens: 'Cambiar lente',
    startingIn: 'Empieza en',
    previewInstruction: 'Asegurate de que todo tu cuerpo entre en cuadro y que haya buena luz. Realiza el ejercicio unos 15 segundos despues de la cuenta atras.',
    currentCamera: 'Camara actual: {camera}',
    rear: 'Trasera',
    front: 'Frontal',
    stopCountdown: 'Detener cuenta atras',
    beginCapture: 'Iniciar captura',
    cancel: 'Cancelar',
    capturing: 'Capturando',
    captureInstruction: 'Sigue haciendo el movimiento con naturalidad mientras capturamos unos 18 fotogramas de tu tecnica.',
    progress: 'Progreso',
    stayInFrame: 'Mantente dentro del encuadre hasta que la barra se complete. Nos detendremos automaticamente cuando haya suficiente movimiento.',
    facingModeHint: '{message} Los navegadores tratan facingMode como una sugerencia.',
    cancelCapture: 'Cancelar captura',
    analyzing: 'Analizando postura... esto deberia tardar solo un momento.',
    couldNotComplete: 'No se pudo completar Form Check',
    poseLandmarkScore: 'Puntuacion de landmarks de postura: {score}',
    lightingScore: 'Puntuacion de iluminacion: {score}',
    poseQualityTip: 'Consejo: aleja mas la camara para que hombros y caderas sigan visibles.',
    qualityReadFailure:
      'No pudimos obtener una lectura consistente de tu tecnica. Prueba a alejarte para que hombros y caderas sigan visibles y asegurate de que la luz sea uniforme.',
    tryAgain: 'Intentar de nuevo',
    verdictPass: 'APROBADO',
    verdictBorderline: 'LIMITADO',
    verdictFail: 'NO APROBADO',
    unknown: 'DESCONOCIDO',
    noAdditionalTips: 'No recibimos consejos adicionales del proveedor.',
    preparingAudio: 'Preparando audio...',
    replayTips: 'Repetir consejos',
    playTips: 'Reproducir consejos',
    runAgain: 'Ejecutar de nuevo',
    whatWeMeasured: 'Lo que medimos',
    framesUsed: 'Fotogramas usados: {value}',
    landmarkOkRatio: 'Ratio de landmarks OK: {value}',
    provider: 'Proveedor: {value}',
    flags: 'Flags: {value}',
    none: 'ninguno',
    uploadedBytes: 'Bytes subidos (est.): {value} KB',
    camera: 'Camara: {value}',
    unknownLower: 'desconocida',
    closeFormCheck: 'Cerrar Form Check',
    title: 'AI Form Check',
    description: 'Graba tu ejercicio para recibir observaciones generadas por IA sobre tu tecnica. Los resultados son informativos y no sustituyen a un entrenador profesional.',
    startRecording: 'Iniciar grabacion',
    privacyNote: 'Procesamos unos pocos fotogramas con IA segura. Guardamos solo las puntuaciones y no almacenamos imagenes.',
    consentNote: 'Al iniciar Form Check aceptas el procesamiento off-device para el analisis postural.',
    modalTitle: 'Form Check',
    requestFailed: 'Form Check no se pudo completar. Intentalo de nuevo.',
  },
  rewardedUnlock: {
    progress: 'Progreso de desbloqueo: {completed}/{required}',
    upgrade: 'Pasar a Ultra',
    genericExtra: 'Desbloquear extra para {targetLabel}',
    fallbackGeneric: 'Abre la app de Forza en iPhone para desbloquear este acceso bonus.',
    voiceCoach: {
      headline: 'Toca para iniciar tu Forza AI Coach',
      body: 'Consigue acceso completo a Voice Coach con Ultra. Prefieres un impulso rapido? Mira anuncios cortos para desbloquear 1 minuto extra.',
      button: 'Desbloquear 1 minuto extra',
      fallback: 'Abre la app de Forza en iPhone para desbloquear un minuto extra.',
    },
    voiceNote: {
      headline: 'Necesitas una comprobacion de voz mas? Desbloquea una nota de voz extra.',
      button: 'Desbloquear nota de voz extra',
    },
    mealDay: {
      headline: 'Necesitas un check-in de comidas mas hoy? Desbloquea un check-in bonus.',
      button: 'Desbloquear check-in bonus',
    },
    questReschedule: {
      headline: 'Quieres un refresh del plan mas hoy? Desbloquea un refresh extra.',
      button: 'Desbloquear refresh extra',
    },
    default: {
      headline: 'Desbloquear acceso bonus.',
      button: 'Desbloquear acceso bonus',
    },
  },
  aiCoach: {
    phaseStarting: 'Conectando…',
    phaseListening: 'Escuchando…',
    phaseTranscribing: 'Transcribiendo…',
    phaseThinking: 'Pensando…',
    phaseSpeaking: 'Hablando…',
    statusPreparingOnDeviceVoice: 'Preparando voz en el dispositivo…',
    statusOnDeviceVoiceReady: 'La voz en el dispositivo esta lista',
    cloudVoiceDescriptionFree: 'La forma mas rapida de empezar. Los usuarios free pueden seguir necesitando desbloqueos con anuncios para sesiones cortas.',
    cloudVoiceDescriptionPaid: 'La forma mas rapida de empezar. Usa voz en la nube en lugar del motor local.',
    onDeviceVoiceReadyLabel: 'Voz en el dispositivo',
    onDeviceVoiceWarmingLabel: 'Voz en el dispositivo (calentando…)',
    cloudVoiceLabel: 'Voz en la nube',
    monthlyLimitReached: 'Se alcanzo el limite mensual de AI Coach.',
    fallbackFailed: 'Fallo el fallback de Voice Coach. Intentalo de nuevo.',
    quotaLocked: 'Voice Coach bloqueado.',
    idleTimeout: 'La sesion se cerro por inactividad.',
    genericError: 'Error de Voice Coach.',
    kokoroFallback: 'Kokoro fallo. Cambiando al TTS del servidor.',
    micUnavailableHttp:
      'El microfono de Voice Coach no esta disponible en HTTP inseguro dentro del WebView de iOS. Usa HTTPS para EXPO_PUBLIC_WEB_BASE_URL y recompila el cliente dev.',
    micUnavailableGeneric: 'La API de microfono no esta disponible en este entorno. Abre Forza en un contexto HTTPS seguro y vuelve a intentarlo.',
    micPermissionDenied: 'Permiso de microfono denegado. Activa el acceso al microfono y vuelve a intentarlo.',
    micNotFound: 'No se encontro ningun microfono utilizable. Revisa los permisos del microfono en iPhone y vuelve a intentarlo.',
    sessionStartFailed: 'No se pudo iniciar la sesion de voz.',
    rewardedAdsNativeOnly: 'Los anuncios reward estan disponibles en la app de iOS.',
    unlockPendingVerification: 'El minuto extra casi esta listo. Esperando verificacion...',
    openingUnlock: 'Abriendo desbloqueo...',
    sessionTitle: 'Iniciar sesion de AI Coach',
    sessionTitleLimit: 'Se alcanzo el limite mensual de AI Coach.',
    statusPrefix: 'Estado:',
    offlineMode: '(sin conexion: {mode})',
    ttsPrefix: 'TTS:',
    ttsError: '(error)',
    ttsPlaying: '(reproduciendo)',
    httpFallbackActive: 'Fallback HTTP activo',
    limitReachedBody: 'Has alcanzado tu limite mensual.',
    upgradePrompt: 'Quieres acceso completo?',
    upgradeCta: 'Pasar a Ultra',
    voiceModalTitle: 'Elige tu voz',
    voiceModalRecommendedBadge: 'Recomendado',
    voiceModalRecommendedTitle: 'Ideal para usar AI Coach con frecuencia',
    voiceModalRecommendedBody:
      'Descargar la voz en el dispositivo es una configuracion unica. Despues, el coaching por voz dura mas sin desbloqueos repetidos con anuncios.',
    voiceModalDownloadTitle: 'Descargar la voz en este iPhone',
    voiceModalDownloadBody: 'Configuracion unica, alrededor de 300 MB.',
    voiceModalCloudTitle: 'Usar voz en la nube ahora',
    voiceModalLater: 'Quizas mas tarde',
    readyModalTitle: 'Voz en el dispositivo lista',
    readyModalHeadline: 'Ahora hay coaching por voz mas largo disponible',
    readyModalBody: 'La configuracion inicial esta completa. Las siguientes sesiones de voz en el dispositivo deberian empezar mucho mas rapido.',
    readyModalStartTitle: 'Empezar a escuchar',
    readyModalStartBody: 'Inicia ahora tu primera sesion de voz en el dispositivo.',
    readyModalCloudTitle: 'Usar voz en la nube en su lugar',
    readyModalCloudBody: 'Salta la ruta local en esta sesion y empieza de inmediato con voz en la nube.',
  },
  liveCoach: {
    limitReachedTitle: 'Limite mensual alcanzado',
    limitReachedBody: 'Has usado todos tus minutos de AI Coach de este mes. Sube de plan para conseguir mas.',
    connectionErrorTitle: 'Error de conexion',
    connectionUnavailable: 'La conexion de Live Coach no esta disponible. Cierra y vuelve a intentarlo.',
    audioSendFailed: 'El envio de audio de Live Coach fallo. Cierra y vuelve a intentarlo.',
    microphoneStartFailed: 'El microfono de Live Coach no pudo iniciarse. Cierra y vuelve a intentarlo.',
    wrongQuestContext: 'Live Coach no recibio el contexto de la quest seleccionada. Cierra y vuelve a intentarlo.',
    connectionClosed: 'La conexion de Live Coach se cerro.',
    connectionFailed: 'La conexion de Live Coach fallo.',
    genericError: 'Error de Live Coach.',
    inactiveTimeout: 'La sesion se cerro por inactividad.',
    connectFailed: 'No se pudo conectar.',
    sessionCreateFailed: 'No se pudo crear la sesion de Live Coach.',
    handshakeTimeout: 'El handshake de Live Coach no se completo. Reinicia el servidor y vuelve a intentarlo.',
    readyTimeout: 'Live Coach no termino de preparar la quest seleccionada. Cierra y vuelve a intentarlo.',
    loading: 'Conectando con AI Coach...',
    usageCacheWarning: 'No se pudo actualizar el uso. Se usa la cuota en cache.',
    ready: 'Live Coach listo',
    preparing: 'Preparando workout...',
    connecting: 'Conectando...',
  },
  leaderboard: {
    pageTitle: 'Clasificacion',
    tabs: {
      global: 'Global',
      regional: 'Regional',
      myLeague: 'Mi liga',
      duel: 'Duelo',
    },
    loading: 'Cargando clasificacion...',
    loadingDuel: 'Cargando estado del duelo...',
    loadFailed: 'No se pudieron cargar los datos. Intentalo de nuevo mas tarde.',
    noData: 'No hay datos de clasificacion',
    noActiveOrPendingDuels: 'No hay duelos activos ni pendientes.',
    globalRankings: 'Clasificacion global',
    locationTitle: 'Ubicacion: {location}',
    leagueFallback: 'Liga',
    tierFallback: 'Tier',
    myRank: 'Tu posicion: {rank} / {total}',
    currentRivalry: 'Rivalidad actual',
    view: 'Ver',
    openDuel: 'Abrir duelo',
    review: 'Revisar',
    opponent: 'Oponente',
    you: 'Tu',
    youVs: 'Tu vs {opponent}',
    challengedYou: '{opponent} te ha desafiado',
    youChallenged: 'Has desafiado a {opponent}',
    timeLeft: '{time} restantes',
    expiresIn: 'Caduca en {time}',
    sentExpiresIn: 'Enviada · caduca en {time}',
    lead: 'Ventaja: {value} XP',
    rewardOnWin: 'Recompensa por ganar: {reward}',
    incomingChallenges: 'Desafios entrantes',
    outgoingChallenges: 'Desafios enviados',
    recentHistory: 'Ultimos 5',
    win: 'Victoria',
    loss: 'Derrota',
    tie: 'Empate',
    resultVs: '{result} vs {opponent}',
    available: 'Disponible',
    pending: 'Pendiente',
    inDuel: 'En duelo',
    unavailable: 'No disponible',
    limitReached: 'Limite alcanzado',
    sendChallenge: 'Enviar desafio',
    acceptChallenge: 'Aceptar desafio',
    decline: 'Rechazar',
    cancel: 'Cancelar',
    working: 'Trabajando...',
    helperDefault: 'Duelo de 7 dias. Puntuacion = todos los XP ganados durante el desafio.',
    helperActiveDuelUser: 'Este usuario ya esta en un duelo. Tiempo restante: {time}.',
    helperPendingIncoming: 'Este usuario ya te desafio.',
    helperPendingOutgoing: 'Ya tienes un desafio pendiente con este usuario.',
    helperActiveDuelSelf: 'Ya tienes un duelo activo. Terminalo antes de enviar un nuevo desafio.',
    helperOutgoingLimit: 'Ya tienes 3 desafios salientes pendientes.',
    level: 'Nivel {level}',
    monthlyXp: 'XP mensuales: {xp}',
    lastFive: 'Ultimos 5: {record}',
    status: 'Estado: {status}',
    winnerReward: 'Ganador: {reward}',
    tieReward: 'Empate: {reward}',
    locationModalTitle: 'Define tu ubicacion',
    locationModalBody: 'Para ver la clasificacion regional, indica tu pais.',
    locationPlaceholder: 'p. ej. Espana',
    locationInvalid: 'Introduce un pais valido.',
    locationSaveFailed: 'No se pudo guardar la ubicacion.',
    save: 'Guardar',
    savedToast: 'Ubicacion guardada',
    challengeSent: 'Desafio enviado',
    challengeAccepted: 'Desafio aceptado',
    challengeDeclined: 'Desafio rechazado',
    sendChallengeFailed: 'No se pudo enviar el desafio.',
    acceptChallengeFailed: 'No se pudo aceptar el desafio.',
    declineChallengeFailed: 'No se pudo rechazar el desafio.',
    winRewardValue: '750 Auras + 200 XP',
    tieRewardValue: '375 Auras + 100 XP cada uno',
  },
  subscription: {
    badge: 'Forza Ultra',
    heroTitle: 'Consigue entrenamientos guiados, revisiones mas rapidas y mas control.',
    heroBody:
      'Ultra es para quienes quieren coaching con IA manos libres, Form Check dentro del workout y mas flexibilidad cuando cambia el plan.',
    currentPlan: 'Plan actual',
    active: 'Activo',
    monthly: 'Mensual',
    billingNote: 'Se renueva cada mes hasta que lo canceles. Puedes cancelarlo cuando quieras en la configuracion de suscripciones de tu cuenta Apple.',
    refreshEntitlement: 'Actualizar entitlement del servidor',
    signInBeforePurchasing: 'Inicia sesion antes de comprar Ultra',
    nativeUnavailable: 'Abre Forza en iPhone para comprar, restaurar o gestionar Ultra con Apple IAP.',
    paymentNoticeLead: 'El pago lo procesa Apple. Al comprar, aceptas los',
    and: 'y',
    actions: {
      purchase: 'Iniciar Ultra en la app iOS',
      restore: 'Ya estas suscrito? Restaurar compra',
      manage: 'Gestionar suscripcion',
    },
    status: {
      pending: '{action} iniciada...',
      genericAction: 'Accion de suscripcion',
      successActive: 'El acceso Ultra esta activo en esta cuenta.',
      successInactive: 'Se actualizo el estado de compra. Ultra todavia no esta activo.',
      cancelled: 'Compra cancelada.',
      failed: 'La accion de suscripcion fallo.',
      refreshing: 'Actualizando estado de suscripcion...',
      refreshFailed: 'No se pudo actualizar el estado de la suscripcion.',
    },
    planNames: {
      ultra: 'Ultra',
      freeTier: 'Plan gratuito',
    },
    renewalLabel: 'Se renueva o vence el {date}',
    features: {
      handsFreeTitle: 'AI Coach manos libres durante los workouts',
      handsFreeBody: 'Inicia coaching por voz guiado sin ver anuncios antes, para que puedas entrenar sin quedarte mirando el telefono.',
      formCheckTitle: 'Form Check dentro del temporizador del workout',
      formCheckBody: 'Abre Form Check directamente desde sesiones temporizadas cuando quieras feedback de postura a mitad del workout.',
      higherLimitsTitle: 'Limites mas altos en voz, meal y form check',
      higherLimitsBody: 'Consigue una cuota incluida mayor para feedback frecuente en notas de voz, verificacion de meals y form checks.',
      rescheduleTitle: 'Mas margen para reprogramar tu plan',
      rescheduleBody: 'Ajusta objetivos y regenera workouts semanales con mas frecuencia cuando cambie tu agenda.',
    },
  },
  healthSources: {
    eyebrow: 'Fuentes y descargo',
    title: 'Fuentes de salud',
    intro:
      'Esta pagina enumera las referencias de salud publica detras de los consejos que ves en Forza y explica que numeros dentro de la app son valores por defecto del producto y no consejo medico personalizado.',
    lastUpdated: 'Ultima actualizacion:',
    medicalDisclaimerTitle: 'Descargo medico',
    medicalDisclaimerBody:
      'Forza es una app de bienestar, no un dispositivo medico. Todo lo que hay en la app - planes, objetivos, consejos de coaching y biblioteca de hechos - es solo informacion general y no sustituye el consejo medico profesional. Habla con un profesional sanitario cualificado antes de empezar o cambiar cualquier rutina de ejercicio, nutricion o sueno, especialmente si tienes una condicion medica, una lesion o estas tomando medicacion.',
    searchLabel: 'Buscar IDs de facts, IDs de fuentes o palabras clave',
    searchPlaceholder: 'Prueba F001, sueno, proteina, ACT-CDC...',
    referencesTitle: 'Referencias de salud publica',
    planningDefaultsTitle: 'Valores por defecto de planificacion de Forza',
    planningDefaultsBody: 'Estos son los valores iniciales que Forza usa al construir tu plan. Son valores por defecto del producto, no prescripciones medicas.',
    factLibraryTitle: 'Biblioteca de facts y fuentes',
    openSource: 'Abrir fuente',
    sourceCountOne: '{count} fuente',
    sourceCountOther: '{count} fuentes',
    defaultCountOne: '{count} valor por defecto',
    defaultCountOther: '{count} valores por defecto',
    factCountOne: '{count} fact',
    factCountOther: '{count} facts',
  },
  questGenerationLoading: {
    title: 'Construyendo tu plan...',
    subtitle: 'Revisando tus preferencias y objetivos',
    alreadyRunningTitle: 'La regeneracion de quests ya esta en curso...',
    alreadyRunningSubtitle: 'Reconectando con una generacion ya iniciada',
    restartedTitle: 'Reiniciando tu plan...',
    restartedSubtitle: 'Una generacion bloqueada anterior se cerro automaticamente',
    errorTitle: 'La generacion de quests fallo',
    errorBody: 'Intentalo de nuevo mas tarde o contacta con soporte.',
    initiating: 'Iniciando',
    finalizing: 'Finalizando',
    didYouKnow: 'Sabias que?',
    seeSources: 'Ver fuentes',
  },
  shop: {
    balanceLabel: 'Auras',
    available: 'disponibles',
    intro: 'Usa las Auras para proteger rachas, aumentar XP y recuperarte sin perder impulso.',
    activeBoosts: 'Boosts activos',
    activeCount: '{count} activos',
    noActiveBoosts: 'No hay boosts activos',
    inventoryTitle: 'Inventario de boosts',
    inventorySubtitle: 'Compra ahora, activa cuando el momento importe.',
    owned: 'En posesion: {count}',
    activeWithTime: 'Activo · {time}',
    activeItemWithTime: '{itemName} · {time}',
    buy: 'Comprar',
    activate: 'Activar',
    extend: 'Extender +24h',
    buyTitle: 'Comprar {itemName}',
    buyBody: 'Anade 1 {itemName} a tu inventario. Podras activarlo mas tarde.',
    activateTitle: 'Activar {itemName}',
    activateBody: 'Activa {itemName} durante 24 horas y consume 1 objeto en posesion.',
    extendTitle: 'Extender {itemName}',
    extendBody: 'Extiende {itemName} 24 horas y consume 1 objeto en posesion.',
    cost: 'Costo',
    consumes: 'Consume',
    oneItem: '1 objeto',
    ownedLabel: 'En posesion',
    cancel: 'Cancelar',
    loadFailed: 'No se pudieron cargar los datos de Auras',
    purchaseFailed: 'La compra fallo',
    activationFailed: 'La activacion fallo',
    purchasedToast: '{itemName} comprado',
    activatedToast: '{itemName} activado',
    extendedToast: '{itemName} extendido +24h',
    expired: 'Caducado',
    items: {
      icebath: {
        name: 'Bano de hielo',
        subtitle: 'Congelar racha',
        description: 'Congela tu racha durante 24h para recuperarte.',
      },
      preworkout: {
        name: 'Pre-workout',
        subtitle: 'Boost de XP',
        description: '2x XP en quests durante las proximas 24h.',
      },
      cheatmeal: {
        name: 'Cheat Meal',
        subtitle: 'Escudo de penalizacion',
        description: 'Sin penalizacion de XP durante 24h.',
      },
    },
  },
  shoppingList: {
    loadFailed: 'No se pudo cargar la lista de la compra.',
    title: 'Lista de compra de 7 dias',
    subtitle: 'Generada a partir de las meals de esta semana',
    close: 'Cerrar lista de compra',
    loading: 'Extrayendo ingredientes...',
    empty: 'No se encontraron meal quests proximas para esta semana.',
    syncing: 'Sincronizando...',
    toggleItem: 'Activar o desactivar {item}',
  },
  dailyMealCheckin: {
    meals: {
      breakfast: 'Desayuno',
      lunch: 'Almuerzo',
      dinner: 'Cena',
      snack: 'Snack / Otro',
    },
    earnedToday: 'Ganado hoy',
    aiAnalysis: 'Analisis IA',
    matchScore: '{value}% MATCH',
    calories: 'Calorias',
    protein: 'Proteina',
    carbs: 'Carbohidratos',
    fat: 'Grasa sat.',
    draftSaved: 'Borrador guardado localmente.',
    tooLong: '{meal} supera los {max} caracteres.',
    requiredUnlessCompleted: '{meal} es obligatorio salvo que ya figure como completado.',
    checkingAvailability: 'Comprobando disponibilidad del check-in diario...',
    unavailable: 'El check-in diario de comidas no esta disponible ahora mismo.',
    analyzingMeals: 'Analizando comidas...',
    submitFailed: 'No se pudo enviar. Intentalo de nuevo.',
    completed: 'Completado',
    placeholder: 'Que comiste en {meal}?',
    dailySummary: 'Resumen diario',
    title: 'Check-in diario de comidas',
    levelUp: 'Level Up!',
    welcomeLevel: 'Bienvenido al Nivel {level}',
    continue: 'Continuar',
    saveDraft: 'Guardar borrador',
    checkingShort: 'Comprobando...',
    alreadySent: 'Ya enviado',
    sendDailyCheckin: 'Enviar check-in diario',
  },
  timerSession: {
    rest: 'Descanso',
    workout: 'Workout',
    recovery: 'Recuperacion',
    next: 'Siguiente',
    seconds: '{count} segundos',
    backToVerification: 'Volver a la verificacion',
    workoutTracker: 'Tracker de workout',
    timerPaused: 'Temporizador en pausa',
    done: 'Listo',
    noTrackableExercises: 'No hay ejercicios trazables disponibles para esta quest.',
    targetValue: 'Objetivo {value}',
    setNumber: 'Set {number}',
    setProgress: 'Set {current}/{total}',
    reps: 'Reps',
    weightUnit: 'Peso {unit}',
    submittingVerification: 'Enviando verificacion...',
    errorOccurred: 'Se produjo un error',
    tryAgain: 'Intentar de nuevo',
    statSet: 'Set',
    statTimer: 'Temporizador',
    statTarget: 'Objetivo',
    pause: 'Pausa',
    resume: 'Reanudar',
    tracker: 'Tracker',
    skip: 'Saltar',
    startFormCheck: 'Iniciar Form Check',
    upNext: 'A continuacion',
    restLabel: 'Descanso {value}',
    loading: 'Cargando temporizador...',
    wakeLockUnavailable: 'El wake lock de pantalla no esta disponible; tu dispositivo podria bloquearse durante el temporizador.',
    formCheckLimitReached: 'Se alcanzo el limite diario de Form Check.',
  },
  profileEditor: {
    saveTraining: 'Guardar ajustes de entrenamiento',
    saveProfile: 'Guardar solo perfil',
    saving: 'Guardando...',
    addCustomEquipment: 'Añadir equipamiento personalizado',
    add: 'Añadir',
    cancel: 'Cancelar',
    optionalNotes: 'Notas opcionales',
    allergiesCheckbox: 'Tengo alergias',
    allergiesPlaceholder: 'Enumere las alergias o reacciones.',
    validationWorkoutDays: 'Elige exactamente {expected} día{suffix} de entrenamiento antes de guardar.',
    modeTraining: {
      title: 'Ajustes de Entrenamiento',
      description: 'Actualice solo la familiaridad con el ejercicio, la actividad semanal, las sesiones por semana y los días de entrenamiento preferidos.',
      badgeLabel: 'Enfoque de entrenamiento',
    },
    modeFull: {
      title: 'Editor de Perfil',
      description: 'Guardar aquí actualiza su perfil sin reconstruir automáticamente su plan de quest.',
      badgeLabel: 'Modo de edición',
    },
    modeRequired: {
      title: 'Editor de Perfil',
      description: 'Guardar aquí actualiza su perfil sin reconstruir automáticamente su plan de quest.',
      badgeLabel: 'Perfil requerido',
    },
  },
};
